module.exports = __webpack_public_path__ + "sa.45e17088c50060fa0549.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/sa.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/sa.svg
// module chunks = styles